import React from 'react';
import { FlexBox, SpacingBox } from './Boxes';
import { InfoParagraph, H2 } from './Typography';

export const EmptyState = ({
  title,
  description,
  TopComponent,
  BottomComponent,
}) => (
    <FlexBox
      flexDirection="column"
      flex={1}
      justifyContent="center"
      alignItems="center">
      <SpacingBox marginBottom="md">{TopComponent}</SpacingBox>
      <H2>{title}</H2>
      <SpacingBox marginBottom="xl">
        <InfoParagraph>{description}</InfoParagraph>
      </SpacingBox>
      {BottomComponent}
    </FlexBox>
);

EmptyState.defaultProps = {
  TopComponent: null,
  BottomComponent: null,
};

export const EmptyStateWrapper = ({
  children,
  condition,
  title,
  description,
  BottomComponent,
  TopComponent,
}) => {
  if (condition) return children();

  return (
    <EmptyState
      title={title}
      description={description}
      BottomComponent={BottomComponent}
      TopComponent={TopComponent}
    />
  );
};

EmptyStateWrapper.defaultProps = {
  TopComponent: null,
  BottomComponent: null,
};
